import styled from 'styled-components';

import { AuthContainer } from './authForm';

export const AltAuthContainer = styled(AuthContainer)`
  margin-top: 10px;
  padding: 24px 0;
  font-size: 0.9rem;
  box-sizing: border-box;
  background: #F1ECE3;
`;

export const AltAuthText = styled.p`
  color: #000000;
`;

export const AltAuthAction = styled.span`
  color: #0095f6;
  cursor: pointer;
`;
